// data/WebDev/WebDevLogoSlider.jsx
import React from "react";
import Slider from "../../components/Slider/Slider";

const items = [
  { src: "/assets/tools_logo/react.svg", alt: "React" },
  { src: "/assets/tools_logo/typescript.svg", alt: "TypeScript" },
  { src: "/assets/tools_logo/javascript.svg", alt: "JavaScript" },
  { src: "/assets/tools_logo/css3.svg", alt: "CSS3" },
  { src: "/assets/tools_logo/angular.svg", alt: "Angular" },
  { src: "/assets/tools_logo/vue.svg", alt: "Vue.js" },
  { src: "/assets/tools_logo/bootstrap.svg", alt: "Bootstrap" },
  { src: "/assets/tools_logo/laravel.svg", alt: "Laravel" },
  { src: "/assets/tools_logo/firebase.svg", alt: "Firebase" },
  { src: "/assets/tools_logo/shopify.svg", alt: "Shopify" },
  { src: "/assets/tools_logo/wordpress.svg", alt: "WordPress" },
  { src: "/assets/tools_logo/TYPO3.svg", alt: "TYPO3" },
];

const renderItem = (item) => <img src={item.src} alt={item.alt} loading="lazy" />;

const WebDevLogoSlider = () => (
  <Slider
    items={items}
    renderItem={renderItem}
    speedDesktop="30s"
    speedMobile="24s"
    label="Unser Technologie-Stack für Webprojekte"
  />
);

export default WebDevLogoSlider;
